import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { MenuSelectors } from "../../../../../redux/selectors";

export const useSpectateCategoryItemsWithFavorites = () => {
  const [categoriesAndFavourites, setCategoriesAndFavourites] = useState([]);
  const [visibleCategories, setVisibleCategories] = useState([]);
  const [hiddenCategories, setHiddenCategories] = useState([]);

  const favouriteSports = useSelector(MenuSelectors.favouriteSports);
  const sportCategories = useSelector(MenuSelectors.sportCategories);
  const numberOfDisplayedItems = useSelector(
    MenuSelectors.numberOfDisplayedItems
  );

  useEffect(() => {
    setCategoriesAndFavourites(
      getFavSportsCategories(favouriteSports, sportCategories)
    );
  }, [favouriteSports, sportCategories]);

  useEffect(() => {
    setVisibleCategories(
      categoriesAndFavourites?.slice(
        0,
        numberOfDisplayedItems || categoriesAndFavourites?.length
      )
    );
  }, [categoriesAndFavourites, numberOfDisplayedItems]);

  useEffect(() => {
    setHiddenCategories(
      categoriesAndFavourites?.filter(x => !visibleCategories.includes(x))
    );
  }, [categoriesAndFavourites, visibleCategories]);

  return { visibleCategories, hiddenCategories, categoriesAndFavourites };
};

const getFavSportsCategories = (favouriteSports, sportCategories) => {
  if (favouriteSports?.length > 0 && sportCategories?.length > 0) {
    let quickLinksCategories = sportCategories?.slice() || [];

    favouriteSports.forEach(fs => {
      quickLinksCategories = quickLinksCategories.filter(qlc =>
        qlc.sportID
          ? parseInt(qlc.sportID) !== parseInt(fs.sportID)
          : parseInt(qlc.ID) !== parseInt(fs.sportID)
      );
    });

    const quickLinksAndFavSports = favouriteSports.concat(quickLinksCategories);

    return favouriteSports
      .concat(quickLinksCategories)
      .slice(0, quickLinksAndFavSports?.length);
  }

  return (sportCategories?.length && sportCategories) || [];
};
